import { logSystem } from 'logger';

import { transportRegistry } from '../Service';
import { ServiceDef, RegistryItem } from '../interfaces';

const transport: RegistryItem = {
	fire(r: ServiceDef): Promise<any> {
		const ws = window.hcstatic.sitews;
		const returnResponseObject = r.returnResponseObject === true;
		const d: Promise<any> = ws.send_jsonrpc(r.target, r.data, returnResponseObject);
		const promise = new Promise<any>((resolve, reject) => {
			d.then(
				(v: any) => {
					logSystem.debug(() => {
						const strval = JSON.stringify(v);
						const loglen = Math.min(strval.length, 200);
						const ellipsis = loglen < strval.length ? '...' : '';
						return `${r.target} => ${strval.slice(0, loglen)}${ellipsis}`;
					});
					// promise.ioArgs = d.ioArgs;
					resolve(v);
				},
				(e: any) => {
					logSystem.error(`${r.target} !!!=>`, e);
					reject(e);
				}
			);
		});
		return promise;
	}
};

transportRegistry.set('WEBSOCKET', transport);
